import React from "react";
import { HiOutlineXMark } from "react-icons/hi2";
import { MobileMenuUser } from "./MobileMenuUser";
import { NavList } from "./NavList";
import { roundedBtn, btnHover } from "./designTokens";

export function MobileMenu({
  isOpen,
  onClose,
  navItems,
  isActive,
  handleNavigation,
  user,
  handleLogout,
  menuTitle,
  t,
}) {
  if (!isOpen) return null;

  return (
    <div
      className="lg:hidden fixed inset-0 z-50"
      role="dialog"
      aria-modal="true"
      aria-label="Menu de navigation"
    >
      <div
        id="mobile-menu"
        className="absolute inset-0 w-full h-full bg-slate-900 flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-4 sm:px-6 py-4 sm:py-5 border-b border-white/10 shrink-0">
          <h2 className="text-lg sm:text-xl font-semibold text-white">
            {menuTitle || "Menu"}
          </h2>
          <button
            onClick={onClose}
            className={`p-2.5 ${roundedBtn} ${btnHover} transition-colors text-white`}
            aria-label="Fermer le menu"
          >
            <HiOutlineXMark className="w-6 h-6" />
          </button>
        </div>

        <nav className="flex-1 px-4 sm:px-6 py-6 space-y-0.5 overflow-y-auto min-h-0">
          <NavList
            items={navItems}
            isActive={isActive}
            onSelect={handleNavigation}
            iconOnly={false}
          />
        </nav>

        <MobileMenuUser
          user={user}
          handleLogout={handleLogout}
          onClose={onClose}
          t={t}
        />
      </div>
    </div>
  );
}
